export const site = "CKOB"; //"EDB" | "CKOB"
